import { For, Show } from "solid-js";
import { groupesBioagresseurs } from "../domaine/portefeuille";

const capitaliser = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

/**
 * Une liste de noms, un par étiquette : plus lisible qu'une suite séparée par
 * des virgules, surtout quand les noms en contiennent eux-mêmes.
 */
export function Etiquettes(props: { valeurs: string[]; latin?: boolean }) {
  return (
    <ul class="etiquettes etiquettes-petites" classList={{ latin: props.latin ?? false }}>
      <For each={props.valeurs.map((v) => v.trim()).filter(Boolean)}>{(v) => <li>{v}</li>}</For>
    </ul>
  );
}

/**
 * Bioagresseurs saisis en texte libre : les noms seuls en étiquettes, et chaque
 * groupe (« Lépidoptères ») suivi de ses espèces en étiquettes.
 */
export function ListeBioagresseurs(props: { elements: string[] }) {
  const groupes = () => groupesBioagresseurs(props.elements);
  const seuls = () => groupes().filter((g) => !g.details.length);
  const avecDetails = () => groupes().filter((g) => g.details.length);
  return (
    <div class="bioagresseurs">
      <Show when={seuls().length}>
        <Etiquettes valeurs={seuls().map((g) => capitaliser(g.nom))} />
      </Show>
      <For each={avecDetails()}>
        {(g) => (
          <div class="bioagresseurs-groupe">
            <span class="bioagresseurs-nom">{capitaliser(g.nom)}</span>
            <Etiquettes valeurs={g.details.map(capitaliser)} />
          </div>
        )}
      </For>
    </div>
  );
}
